import { initContract } from '@ts-rest/core';
import { authAdyenContract } from './adyen.auth.contract';
import { publicAdyenContract } from './adyen.public.contract';

const c = initContract();

export const adyenContract = c.router(
  {
    auth: authAdyenContract,
    public: publicAdyenContract
  },
  {
    pathPrefix: '/adyen',
    strictStatusCodes: true,
  }
);

export * from './adyen.auth.contract';
export * from './adyen.public.contract';
